module.exports = __webpack_public_path__ + "media/images/logo_textbaba-0a48aca9bb2d52aeffd12c50de6dd31c.svg";